/*
 * Public API Surface of @wtw/angularkit/ngkit-asset-url
 */

export * from './lib/ngkit-asset-version.token';
export * from './lib/ngkit-asset-url.service';
